// test2384
(2384 && 0);
